// src/utils/labels.js
//
// Plain-English labels for values that originate in the database/API. Use
// these anywhere a system value could otherwise reach the screen.

export const PRODUCT_LABELS = {
  axo_signal: "AXO Signal",
  axo_snapshot: "AXO website snapshot",
  "6ela": "6ELA",
  telco: "Telco",
  wizzyl: "Wizzyl",
  _unclassified: "No clear fit",
};

export const STAGE_LABELS = {
  new: "New",
  contacted: "Contacted",
  qualified: "Qualified",
  proposal: "Proposal",
  won: "Won",
  lost: "Lost",
};

export const ACTION_LABELS = {
  send_initial_outreach: "Send first outreach",
  send_follow_up: "Send follow-up",
  pitch_website_rebuild: "Pitch website rebuild",
  review_and_prioritise: "Review and prioritise",
  disqualified: "Disqualified",
};

export const OUTCOME_LABELS = {
  deal_won: "Deal won",
  meeting_booked: "Meeting booked",
};

export const HEALTH_SOURCE_LABELS = {
  axo_snapshot: "AXO website snapshot",
  insites_legacy: "Legacy InSites",
  insites: "Legacy InSites",
};

function titleCase(value) {
  return String(value || "")
    .replace(/[-_]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

export function productLabel(value) {
  if (value == null || value === "") return "";
  return PRODUCT_LABELS[value] || PRODUCT_LABELS[String(value).toLowerCase()] || titleCase(value);
}

export function stageLabel(value) {
  if (!value) return "";
  return STAGE_LABELS[value] || titleCase(value);
}

export function actionLabel(value) {
  if (!value) return "";
  return ACTION_LABELS[value] || titleCase(value);
}

export function healthSourceLabel(value) {
  if (!value) return "";
  return HEALTH_SOURCE_LABELS[value] || titleCase(value);
}

export function accountsTypeLabel(value) {
  if (!value) return "";
  const raw = String(value);
  const prefix = "accounts-with-accounts-type-";
  if (raw.startsWith(prefix)) {
    return `${titleCase(raw.slice(prefix.length))} accounts`;
  }
  return raw;
}

const REPLACEMENTS = [
  ...Object.entries(PRODUCT_LABELS),
  ...Object.entries(OUTCOME_LABELS),
  ...Object.entries(HEALTH_SOURCE_LABELS),
  ...Object.entries(ACTION_LABELS),
];

/** Replace known raw system tokens in free text (AI summaries, notes, etc.). */
export function humaniseSystemValues(text) {
  if (text == null) return "";
  let out = String(text);
  for (const [raw, label] of REPLACEMENTS) {
    if (!raw || raw.startsWith("_")) continue;
    out = out.split(raw).join(label);
  }
  out = out.replace(
    /accounts-with-accounts-type-([a-z0-9-]+)/gi,
    (_match, rest) => `${titleCase(rest)} accounts`,
  );
  return out;
}
